var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockUnlimitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 26,
    viewBox: "0 0 168 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60.3844,
    height: 25.7782,
    rx: 12.8891,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8379,
    width: 60.3844,
    height: 25.7782,
    rx: 12.8891,
    fill: "#F5F1DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6758,
    width: 60.3844,
    height: 25.7782,
    rx: 12.8891,
    fill: "#C8E3F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5117,
    width: 60.3844,
    height: 25.7782,
    rx: 12.8891,
    fill: "#D1BEE5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107.35,
    width: 60.3844,
    height: 25.7782,
    rx: 12.8891,
    fill: "#BDECD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockUnlimitedIcon);
export default __webpack_public_path__ + "static/media/unlock-unlimited-icon.7337987d0f26ac7c7b96341cc7c9f3ea.svg";
export { ForwardRef as ReactComponent };